<app-reprocessing-table
  [reprocessingTableService]="reprocessingService"
></app-reprocessing-table>
